import FontPicker from 'font-picker';

window.FontPicker = FontPicker;
